import { JSONSchema7 } from "json-schema";

const driversList = [
    "Apache Drill", "Apache Pinot", "Athena", "BigQuery", "Cassandra", "ClickHouse",
    "Crate", "MySQL", "MySQL2", "Postgres", "Presto", "Redshift", "SAP HANA",
    "SQL Server", "SQLite", "Trino", "Vertica"
]

export const dataSourceFormSchema: JSONSchema7 = {
    type: "object",
    required: ["name", "driver", "host", "username", "password"],
    properties: {
        name: {
            type: "string",
            title: "Connection Name",
            // pattern: "^[A-Za-z0-9_]+$"
            // readOnly: isEditMode,
        },
        driver: {
            type: "string",
            title: "Driver",
            oneOf: driversList.map(driver => ({
                const: driver.split(' ').join().toLowerCase(),
                title: driver
            })),
            default: 'postgres',
        },
        host: {
            type: "string",
            title: "Host Address",
            // pattern: "^[A-Za-z]+$"
        },
        port: {
            type: "number",
            title: "Port",
            pattern: "^[0-9]+$",
        },
        database: {
            type: "string",
            title: "Database",
            // pattern: "^[0-9]+$",
        },
        username: {
            type: "string",
            title: "Database Username",
            // pattern: "^[A-Za-z]+$"
        },
        password: {
            type: "string",
            title: "Database Password",
            //  pattern: "^[0-9]+$", 
        },
    },
};


export const dataSourceFormUiSchema = {
    driver: {
        "ui:enumDisabled": driversList.filter(driver => driver !== 'MySQL' && driver !== 'Postgres').map(driver => driver.split(' ').join().toLowerCase())
    }
};